module.exports = __webpack_public_path__ + "img/changeWidth-2@2x.e447336.png";